<div id="profile" class="watermark">
    <div class="container-fluid px-lg-5">
        <div class="row">
            <div class="col-12">
                <h2 class="title">AISHE</h2>
                <div class="card">
                    <div class="card-body text-center">
                        <!-- <img src="/assets/img/governing/1.jpg" alt="" class="img-fluid"> -->
                        <pdf-viewer src='/assets/pdf/iqac/AISHE.pdf' [render-text]="true" [original-size]="false"
                            style="width: 100%; height: 680px; position: relative;" class="mb-4"></pdf-viewer>
                        <a href="/assets/pdf/iqac/AISHE.pdf" download class="download-btn mt-2">
                            <i class="fa fa-download"></i> Download AISHE PDF
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>